import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { RiskTimeFrameFormComponent } from '../../../components/risk-time-frame-form/risk-time-frame-form.component';
import { QualityManagementService } from '../../../../../services/quality-management.service';
import { RouteService } from '../../../../../services/route.service';
import { AlertNotificationService } from '../../../../../services/alert-notification.service';
import { SavedDataInfo } from '../../../../../models/form/saved-data-info';

@Component({
  selector: 'app-risk-time-frame-edit-page',
  imports: [RiskTimeFrameFormComponent],
  templateUrl: './risk-time-frame-edit-page.component.html',
  styleUrl: './risk-time-frame-edit-page.component.scss'
})
export class RiskTimeFrameEditPageComponent implements OnInit {

  riskTimeFrameId?: number;
  riskTimeFrame?: any;

  constructor(
    private route: ActivatedRoute,
    private qualityManagementService: QualityManagementService,
    private routeService: RouteService,
    private alertNotificationService: AlertNotificationService
  ) { }

  ngOnInit(): void {
    const paramId = this.route.snapshot.paramMap.get('riskTimeFrameId');

    if (paramId) {
      this.riskTimeFrameId = Number(paramId);
      this.loadData(this.riskTimeFrameId);
    }
  }

  get pageTitle(): string {
    return this.riskTimeFrameId ? 'Update Risk Time Frame' : 'Create Risk Time Frame';
  }

  onSavedData(savedData: SavedDataInfo): void {
    if (!savedData.success || this.riskTimeFrameId) {
      return;
    }

    const created = this.qualityManagementService.readResponseKey(savedData.response, 'riskTimeFrame');

    if (created?.riskTimeFrameId) {
      this.routeService.riskTimeFrameDetail(Number(created.riskTimeFrameId));
    } else {
      this.routeService.riskTimeFrameIndex();
    }
  }

  private loadData(riskTimeFrameId: number): void {
    this.qualityManagementService.detailRiskTimeFrame(riskTimeFrameId).subscribe({
      next: (response: any) => {
        this.riskTimeFrame = this.qualityManagementService.readResponseKey(response, 'riskTimeFrame');
      },
      error: (error: any) => {
        console.error('Error loading the risk time frame:', error);
        this.alertNotificationService.error(
          this.qualityManagementService.riskErrorMessage(error, 'Failed to load the risk time frame.')
        );
      }
    });
  }
}
